export interface IntakeAssignResultItem
{
    intakeResetId: number,
    appointmentTypeId: number,
    appointmentTypeDesc: string,
    oldIntakeSetupId?: number,
    oldIntakeSetupName?: string,
    newIntakeSetupId?: number,
    newIntakeSetupName?: string,
    addMissing: boolean,
    updateIntake: boolean,
    workCount?: number,
    errorCount?: number,
    status: number,
    statusDesc: string,
    completionPercentage: number,
    postedDate: string,
    usersId: string
}
export interface IntakePatientInfo
{
    patientEntityId: number,
    consentText?: string,
    consentEmail?: string,
    phoneHome?: string,
    phoneWork?: string,
    phoneOther?: string,
    email?: string,
    sendIntakeLink: boolean
  }

  export interface IntakeItem
  {
    intakeSetupId: number,
    intakeName: string,
    active: boolean
  }
  
  export interface IntakeTypeList
  {
    intakeSetupId: number,
    intakeName: string,
    active: boolean,
    status: string
  }

  export enum contactLinkType {
    consentText = "T",
    consentEmail = "E",
    phoneHome = "H",
    phoneWork = "W",
    phoneOther = "O",
    email = "M"
}
  export interface contactItem
  {
    contactDetails: string,
    type: contactLinkType
  }
  export interface IntakeAppointment
  {
    intakeAssignId: number,
    appointmentId: number,
    appointmentType: string,
    appointmentStartTime: string,
    scheduledWith: string,
    serviceLocation: string,
    intakeName: string,
    intakeStatus: string
  }
  export interface IntakeAppointmentDescription
  {
    appointmentId: number,
    appointmentDescription: string
  }
  export interface IntakeAssignmentActive
  {
    intakeAssignId: number,
    intakeSetupId: number,
    name?: string,
    assignTypeId: number,
    assignTypeDescription: string,
    intakeStatusId?: number,
    intakeStatusDescription: string,
    intakeProgress: number,
    requiredProgress: number,
    deviceId: string,
    appointmentId?: number,
    dueDate?: string,
    userId: string
    createdDate: Date,
    lastUpdatedDate?: Date,
    intakeOfficeCode: string,
    intakeLinkInd: string,
    intakeLinkTransport: string,
    copayAmount: string,
    copayPaid: string,
    eligibility: string
  }
  export interface IntakeAssignmentHistoric
  {
    intakeAssignId: number,
    intakeSetupId: number,
    name?: string,
    assignTypeId: number,
    assignTypeDescription: string,
    intakeStatusId?: number,
    intakeStatusDescription: string,
    intakeProgress: number,
    requiredProgress: number,
    deviceId: string,
    appointmentId?: number,
    dueDate?: string,
    userId: string
    createdDate: Date,
    archiveDate?: Date,
    intakeLinkInd: string,
    intakeLinkTransport: string,
    copayAmount: string,
    copayPaid: string,
    eligibility: string
  }
  export interface IntakeRefreshActive{
    intakeItemList: IntakeItem[],
    intakeAppointmentList: IntakeAppointment[],
    intakeAssignmentList: IntakeAssignmentActive[]
  }
  export interface IntakeRefreshHistoric{
    intakeItemList: IntakeItem[],
    intakeAssignmentList: IntakeAssignmentHistoric[]
  }

  export interface IntakeSaveRequest{
    patientId: number,
    intakeAssignId?: number,
    intakeSetupId: number,
    assignTypeId: number,
    appointmentId?: number,
    dueDate?: Date
  }
  export interface IntakeDeleteRequest{
    patientId: number,
    intakeAssignId?: number
  }

  export interface IntakeResponse{
    successful: boolean,
    errorMessage: string
  }

  export interface IntakeLinkCreateRequest{
    patientId: number,
    intakeAssignId: number,
    linkTransport: string,
    linkType: string,
    sendNow: boolean
  }

  export interface IntakeGetOfficeCodeRequest{
    patientId: number,
    intakeAssignId: number,
    displayInd: boolean
  }
  export interface IntakeOfficeCodePostRequest{
    patientId: number,
    intakeAssignId: number,
    officeCode: string
  }
  export interface IntakeOfficeCodeResponse{
    officeCode: string,
    lastName?: string,
    birthDate?: Date,
    postedInd: boolean
  }